import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _dec2, _dec3, _class, _class2, _descriptor, _descriptor2, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "f15d8QWS/9Oz7zrGyr7Vhqu", "testInspector", undefined);

// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html
import { _decorator, Component } from "cc";
var ccclass = _decorator.ccclass,
    property = _decorator.property,
    inspector = _decorator.inspector,
    menu = _decorator.menu;
var testInspector = (_dec = ccclass('testInspector'), _dec2 = menu("autoBind"), _dec3 = inspector("packages://hello-test/inspector.js"), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(testInspector, _Component);

  function testInspector() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "com_name", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "ignore_binded", _descriptor2, _assertThisInitialized(_this));

    return _this;
  }
  /**匹配的 item */
  // var bindLimitArr = [
  //     "a_lbl_", 名字相同
  //     "a_sp_", 名字相同
  //      "a_pg_", //名字相同
  //     "a_n_", 名字相同
  //     "a_btn_", 名字相同
  //     "a_sf_xx", 名字 xx
  //     "a_dg_", 名字相同
  //     "a_sk_", 名字相同
  //     "a_pfb_",  // 对应 prefab 的名字： pfb_xxx
  // ]
  //点击事件   btn_名字


  return testInspector;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "com_name", [property], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "ignore_binded", [property], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "1";
  }
})), _class2)) || _class) || _class) || _class);
export { testInspector as default };

_cclegacy._RF.pop();